import { MetaAdReferral } from 'data/firestore/globals';
import getAdPreview from './getAdPreview';
import {
    AdIdLabel,
    AdIdRow,
    AdIdText,
    AdIdValue,
    AdImage,
    AdText,
    DropDownTitle,
    InfoContainer,
    OpenAdLink,
    StyledCopyToClipboardButton,
} from './styled';

interface PaidAdCardProps {
    referral: MetaAdReferral;
}

const PaidAdCard = ({ referral }: PaidAdCardProps) => {
    const preview = getAdPreview(referral);

    return (
        <>
            {preview.imageUrl ? <AdImage src={preview.imageUrl} alt="" /> : null}
            {preview.title ? <DropDownTitle>{preview.title}</DropDownTitle> : null}
            {preview.body ? <AdText>{preview.body}</AdText> : null}
            {preview.adId ? (
                <InfoContainer>
                    <AdIdRow>
                        <AdIdText>
                            <AdIdLabel>Ad ID</AdIdLabel>
                            <AdIdValue>{preview.adId}</AdIdValue>
                        </AdIdText>
                        <StyledCopyToClipboardButton
                            mode="icon"
                            value={preview.adId}
                            borderRadius="semi-square"
                        />
                    </AdIdRow>
                </InfoContainer>
            ) : null}
            {preview.linkUrl ? (
                <OpenAdLink href={preview.linkUrl} target="_blank" rel="noreferrer">
                    Open ad
                </OpenAdLink>
            ) : null}
        </>
    );
};

export default PaidAdCard;
